import request from './adminRequest'

export const consultingApi = {
  listConsulting (params) {
    return request.get('/consultings', { params: params })
  },
  getConsulting (uid) {
    return request.get('/consultings/' + uid)
  },
  saveConsulting (data) {
    return request.post('/consultings/', data)
  },
  updateConsulting (uid, data) {
    return request.put('/consultings/' + uid, data)
  },
  deleteConsulting (uid) {
    return request.delete('/consultings/' + uid)
  },

}
export default consultingApi
